// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "checkbox-1lInW";
var _3 = "checkbox_checked-h0uJK";
export { _1 as "__esModule", _2 as "checkbox", _3 as "checkbox_checked" }
export default { "__esModule": _1, "checkbox": _2, "checkbox_checked": _3 }
